import { createSelector, Selector } from 'reselect';

import { RootState } from '../';
import { Invoices, Invoice, Services, Service } from './interfaces';

export const copyrightIdsSelector: Selector<RootState, string[]> = ({ transactions }) => {
  return transactions.copyrightIds || [];
};

export const currentInvoiceSelector: Selector<RootState, Invoice> = ({ transactions }) => {
  return transactions.currentInvoice;
};

export const getInvoiceCopyrightIds = () => {
  return createSelector<RootState, string[], string[]>([copyrightIdsSelector], (copyrightIds) => {
    return copyrightIds;
  });
};

export const getCurrentInvoice = () => {
  return createSelector<RootState, Invoice, Invoice>([currentInvoiceSelector], (invoice) => {
    return invoice;
  });
};

export const invoicesSelector: Selector<RootState, Invoices> = ({ transactions }) => {
  return transactions.invoices || {};
};

export const invoiceIdsSelector: Selector<RootState, string[]> = ({ transactions }) => {
  return transactions.invoiceIds || [];
};

export const getPendingInvoices = () => {
  return createSelector<RootState, Invoices, string[], Invoice[]>(
    [invoicesSelector, invoiceIdsSelector],
    (invoices, invoiceIds) => {
      const _items: Invoice[] = [];

      invoiceIds.map((id) => {
        const invoice = invoices[id];
        if (invoice) _items.push(invoice);
      });

      return _items;
    },
  );
};

export const servicesSelector: Selector<RootState, Services> = ({ transactions }) => {
  return transactions.services || {};
};

export const serviceIdsSelector: Selector<RootState, string[]> = ({ transactions }) => {
  return transactions.serviceIds || [];
};

export const getServices = () => {
  return createSelector<RootState, Services, string[], Service[]>(
    [servicesSelector, serviceIdsSelector],
    (services, serviceIds) => {
      const _items: Service[] = [];

      serviceIds.map((id) => {
        const service = services[id];
        if (service) _items.push(service);
      });

      return _items;
    },
  );
};
